import { render } from "./TourpackagesCom.vue?vue&type=template&id=4df4eb44&scoped=true"
import script from "./TourpackagesCom.vue?vue&type=script&lang=js"
export * from "./TourpackagesCom.vue?vue&type=script&lang=js"

import "./TourpackagesCom.vue?vue&type=style&index=0&id=4df4eb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df4eb44"]])

export default __exports__